import * as yup from "yup"

export const editWafers = yup.object().shape({
  codigo: yup
    .number() 
    .nullable() 
    .required("Este campo es requerido"),
  aplica_a: yup
    .string()
    .nullable() 
    .required("Este campo es requerido"),
})

